import { render, staticRenderFns } from "./df-push-card.vue?vue&type=template&id=7b279902"
import script from "./df-push-card.ts?vue&type=script&lang=js&external"
export * from "./df-push-card.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports